import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { ProyectosListComponent } from './proyectos/proyectos-list.component';
import { ProyectoFormComponent } from './proyectos/proyecto-form/proyecto-form.component';
import { EstimacionComponent } from './estimaciones/estimaciones.component';
import { MasterManagementComponent } from './master-management/master-management.component';
import { LayoutComponent } from './layout/layout.component';
import { AuthGuard } from './guards/auth.guard';
import { PermissionGuard } from './guards/permission.guard';
import { TaskExecutionManagerComponent } from './task-execution-manager/task-execution-manager.component';
import { UserManagementComponent } from './user-management/user-management.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ProfileComponent } from './profile/profile.component';
import { SystemConfigComponent } from './system-config/system-config.component'; // NUEVO

const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'login', component: LoginComponent },

  // Callback OAuth: vive FUERA del bloque app/ — el popup recibe el redirect
  // sin tener forzosamente un JWT vigente (el state en Redis es la prueba).
  // Componente standalone cargado de forma lazy.
  {
    path: 'integrations/callback',
    loadComponent: () =>
      import('./integrations/integrations-callback.component')
        .then(m => m.IntegrationsCallbackComponent)
  },

  {
    path: 'app',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { 
        path: 'home', 
        component: DashboardComponent, // NUEVO: La Home ahora es el Dashboard
        canActivate: [PermissionGuard]
      },
      { 
        path: 'proyectos', // NUEVO: Los proyectos tienen su propia ruta
        component: ProyectosListComponent,
        canActivate: [PermissionGuard],
        data: { requiredPermission: 'menu:projects:manage' }
      },
      {
        path: 'proyecto',
        component: ProyectoFormComponent,
        canActivate: [PermissionGuard],
        data: { requiredPermission: 'menu:projects:manage' }
      },
      {
        path: 'ejecuciones',
        component: TaskExecutionManagerComponent,
        canActivate: [PermissionGuard],
        data: { requiredPermission: 'task:execution:manage' }
      },
      { path: 'estimaciones', component: EstimacionComponent },
      { path: 'estimations/:id', component: EstimacionComponent },

      {
        path: 'users',
        component: UserManagementComponent,
        canActivate: [PermissionGuard],
        data: { requiredPermission: 'menu:users:manage' }
      },

      {
        path: 'master-management',
        component: MasterManagementComponent,
        canActivate: [PermissionGuard],
        data: { requiredPermission: 'menu:master:manage' }
      },
      {
        path: 'profile',
        component: ProfileComponent,
        canActivate: [PermissionGuard]
      },
      {
        path: 'metricas',
        loadChildren: () => import('./metrics/metrics.module').then(m => m.MetricsModule),
        canActivate: [PermissionGuard],
        data: { requiredPermission: 'metrics:admin' }
      },
      {
        path: 'system-config', component: SystemConfigComponent,
        canActivate: [PermissionGuard], data: { requiredPermission: 'menu:master:manage' }
      },
      {
        // Mis exportaciones (Punto 10) — componente standalone lazy.
        path: 'exports',
        loadComponent: () =>
          import('./exports-history/exports-history.component')
            .then(m => m.ExportsHistoryComponent),
        canActivate: [PermissionGuard],
        data: { requiredPermission: 'estimation:export' }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}